/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import Notification from './Notification';
import {
  removeNotification,
  startClosingNotification,
} from './redux/actions/notificationActions';
import NotificationCollection from './models/NotificationCollection';
import './notifications.scss';
import { getNotificationsState } from './redux/selectors/notificationsContainerSelector';

export const fadeOutAnimationDuration = 1000;

const mapStateToProps = state => ({
  notifications: getNotificationsState(state),
});

export class NotificationsContainer extends Component {
  componentDidUpdate() {
    this.updateTimers();
  }

  closeNotificationAfterTimer = ({ id, delay }) => {
    setTimeout(() => {
      this.closeNotification({ id });
    }, delay);
  };

  closeNotification = ({ id }) => {
    if (this.props.notifications.has(id) && !this.props.notifications.find(id).isClosing) {
      this.props.startClosingNotification({ id });
      setTimeout(() => {
        this.removeNotification({ id });
      }, fadeOutAnimationDuration);
    }
  };

  removeNotification = ({ id }) => {
    this.props.removeNotification({ id });
    this.removeFromTimers(id);
  };

  addRemoveNotificationTimer = (notification) => {
    if (this.props.ui.timers.indexOf(notification.id) === -1) {
      const timers = [...this.props.ui.timers, notification.id];
      this.props.updateUI('timers', timers);
      this.closeNotificationAfterTimer({
        id: notification.id,
        delay: (notification.duration * 1000) - fadeOutAnimationDuration,
      });
    }
  };

  removeFromTimers = (notificationId) => {
    const timers = [...this.props.ui.timers];
    timers.splice(timers.indexOf(notificationId), 1);
    this.props.updateUI('timers', timers);
  };

  updateTimers = () => {
    this.props.notifications.loop((notification) => {
      if (notification.duration) this.addRemoveNotificationTimer(notification);
    });
  };

  render() {
    return (
      <div className="global_messages">
        {this.props.notifications.map(notification => (
          <Notification
            key={notification.id}
            {...notification}
            onClose={this.closeNotification}
          />
        ))}
      </div>
    );
  }
}

NotificationsContainer.propTypes = {
  notifications: PropTypes.instanceOf(NotificationCollection),
  removeNotification: PropTypes.func,
  startClosingNotification: PropTypes.func,
};

const NotificationsContainerUI = ui({
  key: 'notifications',
  state: {
    timers: [],
  },
})(NotificationsContainer);

export default connect(
  mapStateToProps,
  {
    removeNotification,
    startClosingNotification,
  },
)(NotificationsContainerUI);
